var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 290,
    viewBox: "0 0 256 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.844 289.088L23.6618 260.166L0.445312 -0.234375H255.555L232.314 260.125L127.844 289.088Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.417 243.547L232.278 21.0576H128V266.951L212.417 243.547Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.668 117.636L56.5304 149.572H127.999V117.636H53.668Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.918 52.9951L50.8212 84.9325H128.001V52.9951H47.918Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.001 200.58L127.861 200.618L92.2925 191.013L90.0188 165.542H57.959L62.4334 215.688L127.854 233.849L128.001 233.808V200.58Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.128 117.637L207.893 52.9951H127.891V84.9325H172.893L169.987 117.637H127.891V149.573H167.218L163.51 190.993L127.891 200.607V233.834L193.363 215.688L193.844 210.292L201.349 126.213L202.128 117.637Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 290,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.43b6f4bdbc0f36b9f2dd15c6ebbcea15.svg";
export { ForwardRef as ReactComponent };